<template>
    <div id="app">
        <v-app>
            <Header />
            <div class="page-layout">
                <div class="columns">
                    <div class="column is-offset-1 is-10">
                        <v-content>
                            <v-container fluid>
                                <vue-page-transition name="fade-in-left">
                                    <router-view />
                                </vue-page-transition>
                            </v-container>
                        </v-content>
                    </div>
                </div>
            </div>
            <Footer />
        </v-app>
    </div>
</template>

<script>
import { Header, Footer } from "./shared/components";

export default {
    name: "App",
    components: {
        Header,
        Footer,
    },
    data() {
        return {
        };
    },
    beforeCreate() {
        this.$router.push(window.location.pathname+window.location.search);
        if (window.location.pathname !== '/admin-login'){
          this.$store.dispatch('GET_AUTH_USER').catch(() => {
            this.$router.push({path: '/admin-login'});
            this.$store.dispatch('LOGOUT');
          });
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.IS_LOGGED_IN;
        },
    },
};
</script>

<style>
body {
    font-family: "Fira Sans Condensed", "Roboto", Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #fbfbfb;
    overflow: hidden;
}

.page-layout {
    margin: 10px 50px 50px;
}

@media (max-width: 960px) {
    .page-layout {
        margin: 0px 10px 10px;
    }
}

</style>
